import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class LiveReForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    liveReDataUid: '',
                    liveReReplaceTistory: 'replace'
                },
                validated: false
            })
        }
    }

    @autobind
    handleChangeDataUid(value) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                liveReDataUid: {
                    $set: value
                },
            },
            validated: {
                $set: value.length > 0
            }
        }))
    }

    @autobind
    handleChangeReplaceTistory(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                liveReReplaceTistory: {
                    $set: item.value
                },
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin31">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        Data-uid 입력
                        <TInputForm type="text" className="tf_set tf_set200" title="Data-uid 입력"
                                    value={data.setting.liveReDataUid} placeholder="Data-uid를 넣어주세요."
                                    onChange={this.handleChangeDataUid}/>
                    </div>
                </div>

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        티스토리 댓글을
                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'표시합니다.', value:'' },
                            { label:'표시하지 않습니다.', value:'replace' },
                        ]} selected={data.setting.liveReReplaceTistory} onSelect={this.handleChangeReplaceTistory}/>
                    </div>
                </div>

                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            라이브리 코드를 발급 받아주세요.
                            <a href="https://livere.com/apply" target="_blank" className="link_other">설정하러 가기</a>
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            코드 화면에서 ‘티스토리’탭을 클릭 후, 우측에 ‘data-uid copy’ 버튼을 클릭해 주세요.
                        </li>
                        <li>
                            <span className="txt_em">3</span>
                            이후 입력창에 복사된 내용을 붙여넣으시고, 적용을 클릭하면 설치가 완료됩니다.
                        </li>
                    </ol>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

LiveReForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default LiveReForm
